var _path, _path2, _path3, _path4, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiskette(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.82051C0 1.26235 1.58811 0 3.54839 0H12.8026C13.7434 0 14.6462 0.297617 15.3114 0.826328L18.9604 3.72684C19.6256 4.25555 20 4.97319 20 5.72103V17.1795C20 18.7377 18.4119 20 16.4516 20H3.54839C1.58811 20 0 18.7377 0 17.1795V2.82051ZM3.54839 1.53846C2.65705 1.53846 1.93548 2.11201 1.93548 2.82051V17.1795C1.93548 17.888 2.65705 18.4615 3.54839 18.4615H16.4516C17.3429 18.4615 18.0645 17.888 18.0645 17.1795V5.72103C18.0645 5.38168 17.8944 5.05522 17.5918 4.8147L13.9428 1.91418C13.6402 1.67367 13.2295 1.53846 12.8026 1.53846H3.54839Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94865 1.53825C5.74505 1.53825 4.76894 2.22153 4.76894 3.06406V5.93594C4.76894 6.77847 5.74504 7.46175 6.94865 7.46175H11.0513C12.255 7.46175 13.2311 6.77847 13.2311 5.93594V3.06406C13.2311 2.22153 12.255 1.53825 11.0513 1.53825H6.94865ZM4 3.06406C4 1.92426 5.32037 1 6.94865 1H11.0513C12.6796 1 14 1.92426 14 3.06406V5.93594C14 7.07574 12.6796 8 11.0513 8H6.94865C5.32037 8 4 7.07574 4 5.93594V3.06406Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5897 3.23068C10.349 3.23068 10.1538 3.52351 10.1538 3.8846V5.1154C10.1538 5.47649 10.349 5.76932 10.5897 5.76932H11.4103C11.651 5.76932 11.8462 5.47649 11.8462 5.1154V3.8846C11.8462 3.52351 11.651 3.23068 11.4103 3.23068H10.5897ZM10 3.8846C10 3.39611 10.2641 3 10.5897 3H11.4103C11.7359 3 12 3.39611 12 3.8846V5.1154C12 5.60389 11.7359 6 11.4103 6H10.5897C10.2641 6 10 5.60389 10 5.1154V3.8846Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53838 10.692C6.09405 10.692 4.92272 11.5705 4.92272 12.6538V16.3462C4.92272 17.4295 6.09405 18.308 7.53838 18.308H12.4616C13.9059 18.308 15.0773 17.4295 15.0773 16.3462V12.6538C15.0773 11.5705 13.9059 10.692 12.4616 10.692H7.53838ZM4 12.6538C4 11.1883 5.58445 10 7.53838 10H12.4616C14.4156 10 16 11.1883 16 12.6538V16.3462C16 17.8117 14.4156 19 12.4616 19H7.53838C5.58445 19 4 17.8117 4 16.3462V12.6538Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 16.5,
    x2: 13.5,
    y2: 16.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 12.5,
    x2: 13.5,
    y2: 12.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 14.5,
    x2: 13.5,
    y2: 14.5,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskette);
export default __webpack_public_path__ + "static/media/diskette.e8f04b75.svg";
export { ForwardRef as ReactComponent };